import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';

import { OrderedJoinServiceBase } from '../shared/base/ordered-join-service-base';

@Injectable()
export class UserNotificationsService extends OrderedJoinServiceBase {
  constructor(db: AngularFireDatabase) {
    super(db, '/user-notifications', '/notifications');
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/notifications/user-notifications.service.ts